import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AppService } from "../services/app.service";

@Component({
  selector: "app-pre-authorize",
  templateUrl: "./pre-authorize.component.html",
})
export class PreAuthorizeComponent implements OnInit {
  path: any;
  scheduleappointmentid: any = "";

  constructor(private router: Router, private appservice: AppService) {}

  ngOnInit() {
    this.path = this.router.url;
    const Splitpath = this.path.split("/");
    if (Splitpath && Splitpath.length === 3) {
      this.scheduleappointmentid = Splitpath[2];
      this.viewschedule();
    }
  }

  scheduledview: any = {};
  viewschedule() {
    this.appservice
      .viewscheduleappointment(this.scheduleappointmentid)
      .subscribe((res) => {
        if (res && res["status"] && res["status"]["status"] === 200) {
          if (res["entity"]) {
            this.scheduledview = res["entity"];
            if (this.scheduledview && this.scheduledview.preAuthorized) {
              this.router.navigate([
                "/patient-profile",
                this.scheduleappointmentid,
              ]);
            }
          }
        } else {
          this.router.navigate(["/home"]);
        }
      });
  }

  updatepreauthorize() {
    this.appservice.updatepreauthorize(this.scheduledview).subscribe((res) => {
      if (res && res["status"] && res["status"]["status"] === 200) {
        this.router.navigate(["/patient-profile", this.scheduleappointmentid]);
      }
    });
  }

  gotopreautho() {
    this.router.navigate(["/home"]);
  }
}
